import request from "@/utils/request";

export default function agentGetBindWeChatSCode() {
    return request({
        url: `/user/agent/agentGetBindWeChatSCode`,
    })
}
